module.exports = __webpack_public_path__ + "static/media/cam.ecf2d6d6.svg";